import { locale } from '../data/locale';
import Answers from '../data/answers';

export default class QuestionsShow {
    constructor(logic) {
        this.logic = logic || [];
        const answers = new Answers();
        this.answers = answers.all();
    }

    can() {
        let can = true;

        this.logic.forEach(condition => {
            const operator = condition.operator || '';
            switch (condition.condition.toUpperCase()) {
                case 'LANGUAGE':
                    const includes = (condition.value || []).includes(locale());

                    if (operator === '' && !includes) {
                        can = false;
                    }
                    if (operator === '!' && includes) {
                        can = false;
                    }
                    break;

                case 'SELECTED':
                    const sourceAnswers = this.answers[condition.source] || [];
                    const requiredValues = condition.value || [];
                    const selected = this.allAnswersSelected(sourceAnswers, requiredValues);

                    if (operator === '' && !selected) {
                        can = false;
                    }
                    if (operator === '!' && selected) {
                        can = false;
                    }
                    break;
            }
        });

        return can;
    }

    allAnswersSelected(answers, values) {
        const answersIndexes = [];
        answers.forEach(answer => answersIndexes.push(answer.index));

        const diff = answersIndexes.filter(i => values.indexOf(i) < 0);

        return diff.length === 0;
    }
}